import { AdminCustomerListModel } from 'src/Libs/shop'
import { LanguageReducerState, ShopReducerAction } from './ShopModel'

export const updateShopAuthToken = (contextToken: string): ShopReducerAction => {
  return { type: 'UPDATE_SHOP_AUTH_TOKEN', contextToken: contextToken }
}

export const updateShopSelectedUser = (selectedUserData: AdminCustomerListModel | null): ShopReducerAction => {
  return { type: 'UPDATE_SHOP_SELECTED_USER', selectedUserData: selectedUserData }
}

export const updateShopLanguage = (language: LanguageReducerState[]): ShopReducerAction => {
  return { type: 'UPDATE_SHOP_LANGUAGE', language: language }
}

export const updateShopBasketQuantity = (basketQuantity: number): ShopReducerAction => {
  return { type: 'UPDATE_SHOP_BASKET_QUANTITY', basketQuantity: basketQuantity }
}

export const updateShopAccess = (shopAccess: boolean): ShopReducerAction => {
  return { type: 'UPDATE_SHOP_ACCESS', shopAccess: shopAccess }
}

export const updateCustomerGroupId = (customerGroupId: string | null): ShopReducerAction => {
  return { type: 'UPDATE_CUSTOMER_GROUP_ID', customerGroupId: customerGroupId }
}

export const updateShopAccessKey = (shopAccessKey: string | null): ShopReducerAction => {
  return { type: 'UPDATE_SHOP_ACCESS_KEY', shopAccessKey: shopAccessKey }
}

export const updateShopChannelId = (shopChannelId: string): ShopReducerAction => {
  return { type: 'UPDATE_SHOP_CHANNEL_ID', shopChannelId: shopChannelId }
}

export const updateQntmReminder = (qntmReminder: boolean): ShopReducerAction => {
  return { type: 'UPDATE_QNTM_REMINDER', qntmReminder: qntmReminder }
}
